import { type UseQueryResult } from '@tanstack/react-query';
import { useTestInstanceResponse } from 'services/assist-api/entities/test-instance-response/test-instance-response';
import type { TestInstanceResponseWithResponseItemsAndMediaObjects } from 'services/assist-api/entities/test-instance-response/types';

/**
 * Fetches the response that is needed to display a Mark Response page.
 */
export default function useResponseForMarking(
  responseId: number
): UseQueryResult<
  RequestResponse<TestInstanceResponseWithResponseItemsAndMediaObjects>,
  RequestError
> {
  return useTestInstanceResponse<TestInstanceResponseWithResponseItemsAndMediaObjects>(responseId, {
    groups: [
      'testinstanceresponse-responseitems',
      'testinstanceresponse-mediaobjects',
      'mediaobject-list'
    ],
    include: 'responseItems,mediaObjects'
  });
}
